import {} from 'viem';
import { encodeDeployData, } from 'viem/zksync';
import { CONTRACT_DEPLOYER_ADDRESS } from '../constants.js';
import { sendTransaction } from './sendTransaction.js';
export function deployContract(walletClient, signerClient, publicClient, parameters, isPrivyCrossApp = false) {
    const { abi, args, bytecode, deploymentType, salt, ...request } = parameters;
    const data = encodeDeployData({
        abi,
        args,
        bytecode,
        deploymentType,
        salt,
    });
    // Add the bytecode to the factoryDeps if it's not already there
    request.factoryDeps = request.factoryDeps || [];
    if (!request.factoryDeps.includes(bytecode))
        request.factoryDeps.push(bytecode);
    return sendTransaction(walletClient, signerClient, publicClient, {
        ...request,
        data,
        to: CONTRACT_DEPLOYER_ADDRESS,
    }, isPrivyCrossApp);
}
//# sourceMappingURL=deployContract.js.map